<template>
  <div class="task-breadcrumb-container">
    <div class="task-breadcrumb-left">
      <div class="back">
        <el-tooltip content="返回上一页">
          <i @click="handleBack" class="icon iconfont iconicon_arrow_task_2 activeIconHover"></i>
        </el-tooltip>
      </div>
      <!-- 背景选择 -->
      <el-tooltip content="编辑背景" v-model="colorTooltip" :disabled="!(isBoss || isAdmin || $permission('项目管理-更新项目')) || isDisabledProject">
        <ColorCardSmall
          :dataset="projectInfo"
          @visibleChange="colorVisibleChange"
          @change="colorChange"
          :defaultText="projectInfo.title"
          :disabled="!(isBoss || isAdmin || $permission('项目管理-更新项目')) || isDisabledProject"
          class="project-bread-color"
        ></ColorCardSmall>
      </el-tooltip>
      <!-- 项目下拉框 -->
      <el-popover trigger="click" placement="bottom-end" :offset="50" v-model="projectPopoverVisible" :disabled="isDisabledProject">
        <Project-popover :visible="projectPopoverVisible" @handleClose="handleClose"></Project-popover>
        <div class="project-name" slot="reference">
          <toolTip
            :title="this.projectInfo.title"
            :maxWidth="'270px'"
          >
            <span>{{ this.projectInfo.title }}</span>
          </toolTip>
          <!-- <span>{{ this.projectInfo.title }}</span> -->
          <span class="icon" :class="{down: projectPopoverVisible}" v-if="!isDisabledProject"></span>
        </div>
      </el-popover>
      <!-- 星标 -->
      <div class="star-wrap" v-if="!isDisabledProject">
        <el-tooltip class="item" :content="star ? '取消星标' : '星标'">
          <i
            class="icon iconfont activeIconHover star-icon-con"
            :class="star ? 'iconicon_following' : 'iconicon_focus_on'"
            @click="hanldeStar"
          ></i>
        </el-tooltip>
      </div>
      <!-- 已冻结、已归档 -->
      <div class="disabled-wrap" v-if="isDisabledProject">
        {{projectInfo.status === -2 ? '已冻结' : projectInfo.is_archived === 1 ? '已归档' : ''}}，<span @click="activeProject">激活项目</span>
      </div>
    </div>

    <div class="task-breadcrumb-right">
      <Project-members-popover
        isTask
        :id="projectInfo.project_id"
        :membersLength="membersLength"
        :isHide="isHide"
        :membersArr="membersArr"
        :membersUidArr="membersUidArr"
        :membersDataList="membersDataList"
        :addOrDelPermission="isProjectAdmin"
        :setAdminPermission="isProjectAdmin"
        @handleMembersHide="handleMembersHide"
        @handleSearchMember="handleSearchMember"
      ></Project-members-popover>

      <em></em>

      <MessageInfo
        :messageListTotal="messageListTotal"
        :projectId="projectInfo.project_id"
        @close="fetchProjectUnreadMessage"
        @taskClick="taskClick"
      >
      </MessageInfo>

      <el-tooltip
        effect="dark"
        content="设置"
        placement="bottom"
        :disabled="hideSetTooltip"
        v-if="isProjectAdmin && !isDisabledProject"
        class="project-seting"
      >
        <el-dropdown @command="handleCommand" @visible-change="visibleChange" trigger="click">
          <div>
            <i class="icon iconfont iconicon_setting_project activeIconHover"></i>
          </div>
          <el-dropdown-menu slot="dropdown" class="project-setting-dropdown-wrap">
            <el-dropdown-item
              command="projectSetting"
              v-if="isBoss || isAdmin || $permission('项目管理-更新项目')"
            >
              <i class="icon iconfont iconicon_action_item"></i>
              项目设置
            </el-dropdown-item>
            <el-dropdown-item command="keyframes" v-if="(isBoss || isAdmin)">
              <i class="icon iconfont iconicon_field_management"></i>
              字段管理
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-tooltip>

      <el-tooltip content="项目详情" placement="bottom" v-else>
        <i @click="handleProjectDetail" class="icon iconfont iconicon_help_nor activeStyle activeIconHover"></i>
      </el-tooltip>

      <div class="keyframes-dialog">
        <el-popover
          placement="bottom"
          min-width="278"
          :offset="40"
          trigger="click"
          ref="popover"
          v-model="keyframesVisible"
          @after-leave="closePopver"
        >
          <tableModeHead
            @changeHead="origin"
            @hide="keyframesVisible = false"
            :projectId="projectInfo.project_id"
            :show="keyframesVisible"
          />
          <div slot="reference">
            <div style="height: 24px;"> </div>
          </div>
        </el-popover>
      </div>

    </div>
  </div>
</template>

<script>
import bus from '@/bus'
// api
import api from '@/services/api/home/home'
import apiTask from '@/services/api/task/task'
import apiMsg from '@/services/api/realMessage/realMessage'
// 组件
import MessageInfo from '@/components/messageInfo'
import tableModeHead from '../../tableModeHead'
import ProjectPopover from './projectPopover.vue'
import ProjectMembersPopover from '@/components/projectMembersPopover/index.vue'
import ColorCardSmall from '@/components/colorControl/cardSmall'
import { mapMutations, mapActions, mapState } from 'vuex'

export default {
  props: {
    projectInfo: {
      type: Object,
      default: () => { }
    },
    // 上一级路由的名称，用于返回判断
    fromPathName: {
      type: String,
      default: 'myTask'
    }
  },
  components: {
    MessageInfo,
    tableModeHead,
    ProjectPopover,
    ProjectMembersPopover,
    ColorCardSmall
  },
  computed: {
    // 该项目是否有标星
    star() {
      return this.projectInfo.project_mark_star ? this.projectInfo.project_mark_star.is_mark ? true : false : false
    },
    isProjectAdmin() { // 是否为项目管理员
      return this.isBoss || this.isAdmin
    },
    ...mapState('task/task', {
      isDisabledProject: state => state.isDisabledProject
    })
  },
  data() {
    return {
      colorTooltip: false, // 背景颜色浮窗开关
      projectPopoverVisible: false, //项目下拉框是否显示
      isHide: false, //成员浮窗是否关闭
      membersArr: [], //项目成员数据数组
      membersUidArr: [], //项目成员uid组成的数组
      membersLength: 0, //项目所有成员的数量
      membersDataList: {}, //项目成员集合对象，包括部门名称 ('部门名称: [项目成员]'这样的对象模式)
      messageListTotal: null,
      hideSetTooltip: false, // 是否隐藏项目设置的浮现文字
      editVisible: false,
      keyframesVisible: false,
      istemplateKeyChange: false,
    }
  },
  mounted() {
    bus.$on('fetchProjectUnreadMessage', () => {
      this.fetchProjectUnreadMessage()
    })
    bus.$on('getProjectMembers', () => {
      this.getProjectMembers()
    })
  },
  destroyed() {
    bus.$off('fetchProjectUnreadMessage')
    bus.$off('getProjectMembers')
  },
  watch: {
    projectInfo: {
      handler() {
        this.getProjectMembers() //初始化获取项目成员
        this.fetchProjectUnreadMessage() // 初始化获取消息列表的总数量
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations('project/project', ['set_member_user']),
    ...mapActions('project/project', ['editProject', 'activateProject']),
    async getProjectMembers(keywords) {

      const param = {
        project_id: this.projectInfo.project_id,
        working_status: '在职',
        keyword: keywords
      }
      const result = await apiTask.getProjectMembers(param)
      if(!keywords) {
        this.set_member_user(result)
      }
      if (result) {
        // console.log(res, 111)
        this.membersDataList = {}
        this.membersArr = keywords ? this.membersArr : []

        result.forEach(res => {
          for (let key in res) {
            if (res[key].length) {
              if (!keywords) {
                //有搜索关键字，不可改变现有成员显示
                this.membersArr.push(...res[key]) //获取成员形成一个数组
                this.membersLength = this.membersArr.length

                //获取所有成员uid组成一个数组
                this.membersUidArr = this.membersArr.map(item => { return item.uid })
              }
              this.membersDataList[key] = res[key] //获取成员及部门
            }
          }
        })
      }
    },
    async fetchProjectUnreadMessage() {
      const param = {
        project_id: this.projectInfo.project_id,
        is_read: 0,
        page: 1,
        pre_page: 1
      }
      const res = await apiMsg.historyMessageLogs(param)
      if (res) {
        this.messageListTotal = res.total
      }
    },
    taskClick(data) {
      this.$emit('taskClick', data)
    },
    // 项目管理
    handleCommand(val) {
      switch (val) {
        case "projectSetting":
          bus.$emit('editVisible', true)
          break;
        case 'keyframes':
          this.keyframesVisible = true
          break
      }
    },
    // 根据下拉框的出现与否来判断项目设置的文字是否浮现
    visibleChange(val) {
      this.hideSetTooltip = val
    },
    // 项目详情
    handleProjectDetail() {
      bus.$emit('projectDetailVisible', true)
    },
    //搜索成员
    handleSearchMember(keywords, needInit) {
      this.isHide = false
      this.getProjectMembers(keywords)
      if (needInit) this.getProjectMembers() //需要刷新跨团队项目进度详情
    },
    handleMembersHide() {
      this.isHide = true
    },
    // 去往工作台
    handleBack () {
      // 根据上一级路由的名称判断跳到”我的任务“还是”我的项目“
      // let _url = this.fromPathName === 'starProject' || this.fromPathName === 'projectFolder' ?
      //   './main/myProject/starProject' :
      //   './main/myTask'
      // this.$router.push(_url)
      this.$router.go(-1)
    },
    // 标星或者取消
    async hanldeStar() {
      const param = {
        project_id: this.projectInfo.project_id,
        is_mark: this.star ? 0 : 1 //已标星就需要取消标星，未标星即需要标星
      }
      const res = await api.markStarToTheProject(param)
      if (res) {
        const _msg = this.star ? '取消标记星标成功' : '标记星标成功'
        this.$message({
          message: _msg,
          type: 'success'
        })

        this.$emit('starSuccess')
      }
    },

    origin() {
      this.istemplateKeyChange = true
    },
    closePopver() {
      if (this.istemplateKeyChange) {
        this.istemplateKeyChange = false
        this.$emit('templateKeyChange', 1)
      }
    },
    handleClose() {
      this.projectPopoverVisible = false
    },
    // 背景颜色浮窗显示时 浮窗文字需隐藏
    colorVisibleChange(val) {
      this.colorTooltip = val ? false : false
    },
    async colorChange(val) {
      let {project_id, background_color, background_text} = val
      await this.editProject({
        project_id,
        background_color,
        background_text
      })
      this.$emit('starSuccess')
    },
    async activeProject() {
      await this.$wfAlert('warning', '提示', `你确定要激活该项目?`, '确定')
      await this.activateProject({
        project_id: this.projectInfo.project_id,
        action: this.projectInfo.status === -2 ? 'open_project' : this.projectInfo.is_archived === 1 ? 'active_project' : ''
      })
      this.$emit('starSuccess')
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.task-breadcrumb-container {
  width: 100%;
  height: 72px;
  background: #fff;
  padding: 0 32px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .disabled-wrap {
    padding: 8px 16px;
    border-radius: 8px;
    display: flex;
    background-color: #EEEEEE;
    color: rgba(32, 32, 32, 0.6);
    span {
      color: #2682FF;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .project-seting,
  .iconicon_help_nor {
    margin-left: 31px;
    i {
      font-size: 16px;
    }
  }
  .task-breadcrumb-left {
    display: flex;
    align-items: center;
    .project-bread-color {
      margin-left: 10px;
      display: inline-flex;
      &:hover {
        filter:brightness(90%);
      }
    }
    .project-name {
      font-weight: bold;
      margin: 0 18px 0 12px;
      display: flex;
      align-items: center;
      .icon {
        display: block;
        border-radius: 2px;
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 6px solid rgba(32, 32, 32, .6);
        margin-left: 9px;
        transition: all .3s;
        &.down {
          transform: rotate(180deg);
        }
      }
    }
    .star-wrap {
      .star-icon-con {
        &.iconicon_following {
          color: #FFBE23;
        }
        &.iconicon_focus_on {
          @include fontColorOpacity(.6);
        }
      }
    }
  }
  .task-breadcrumb-right {
    display: flex;
    align-items: center;
    em {
      width: 1px;
      height: 16px;
      background: #202028;
      border-radius: 1px;
      opacity: 0.16;
      margin: 0 23px 0 15px;
    }
  }
}
.project-setting-dropdown-wrap {
  i {
      @include fontColorOpacity(.8);
  }
}
</style>
